// extracted by mini-css-extract-plugin
module.exports = {"group":"group_group__gEYOc","standard":"group_standard__xoteK","article":"group_article__DJgSl"};